type productType = "KLEANZ" | "cams";

// localFetch should not be used inside of this store, since is used for the context of ckfetch
export const useAppStore = defineStore("app", () => {
  const globalNotification = useGlobalNotification();
  const activeLoadingProcesses = ref(new Set<string>());

  /**
   * Indicate the current facility id even if the facility is not yet loaded
   */
  const activeFacilityId = ref<number>();
  const product: productType = "KLEANZ";

  const loading = computed(() => activeLoadingProcesses.value.size > 0);
  const productName = computed(() => (product === "KLEANZ" ? "KLEANZ" : "Cams"));

  const pageTitle = ref(productName.value);

  /**
   * Wraps the promise in a loading state
   * @param realWork
   */
  function startProcess<T>(realWork: PromiseOrFunction<T>, options?: { processName?: string }): Promise<T> {
    const processName = `job ${options?.processName || $ck.utils.getUID()}`;
    activeLoadingProcesses.value.add(processName);

    devConsole.group(`🛠️ Starting process ${processName || ""}`);
    if (options?.processName?.length) {
      devConsole.time(options.processName);
    }

    return $ck.utils
      .unwrapPromise(realWork)
      .then((value: T) => {
        devConsole.log(`🛠️ ${processName} Work Done...`);
        return value;
      })
      .finally(() => {
        devConsole.log(`  ${processName} Finally...`);
        if (options?.processName?.length) {
          devConsole.timeEnd(options.processName);
        }
        devConsole.groupEnd();
        activeLoadingProcesses.value.delete(processName);
      });
  }

  function setProcessLoading(name: string, isLoading: boolean) {
    const processName = `manual ${name}`;
    if (isLoading) {
      activeLoadingProcesses.value.add(processName);
    } else {
      activeLoadingProcesses.value.delete(processName);
    }
  }

  function clearErrors() {
    globalNotification.clearAllPersist(true);
  }

  return {
    loading,
    startProcess,
    setProcessLoading,
    addError: globalNotification.showError.bind(globalNotification),
    addPendingMessage: globalNotification.showPending.bind(globalNotification),
    addWarningMessage: globalNotification.showWarning.bind(globalNotification),
    addSuccessMessage: globalNotification.showSuccess.bind(globalNotification),
    clearErrors,
    /**
     * Indicate the current facility id even if the facility is not yet loaded
     */
    activeFacilityId,
    product,
    productName,
    pageTitle,
  };
});
